'use strict';

export default ($rootScope, modal) => {
  'ngInject';

  return {
    open(paymentData, paymentProvider) {
      var scope = $rootScope.$new();
      scope.paymentData = paymentData;
      scope.paymentProvider = paymentProvider;

      return modal.open({
        template: '<sa-fast-pay-modal payment-data="paymentData" payment-provider="paymentProvider" done="close()"></sa-fast-pay-modal>',
        scope: scope
      }).result;
    },
  };
};



// WEBPACK FOOTER //
// ./app/src/components/fast_pay_modal/fast_pay_modal.service.js